module.exports = __webpack_public_path__ + "img/homepage.4a333e2b.jpg";